// XINCITY central mock data — single source of truth (deterministic demo data)

export const IMAGES = {
  skyline: 'https://images.unsplash.com/photo-1565043534426-8a67ac8671e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  rainyStreet: 'https://images.unsplash.com/photo-1608690158878-1a96b29b455b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  wetStreet: 'https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  neonCity: 'https://images.unsplash.com/photo-1599060052009-24d6d0b0161c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  foggyCity: 'https://images.unsplash.com/photo-1544259342-306eccfec481?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  purpleCity: 'https://images.unsplash.com/photo-1573767291321-c0af2eaf5266?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  car: 'https://images.unsplash.com/photo-1760689041940-2351de731137?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  alleyCar: 'https://images.unsplash.com/photo-1707872489340-8bf43c9e8c21?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  lounge: 'https://images.unsplash.com/photo-1756981168649-0e3c3c8a32f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  redRoom: 'https://images.unsplash.com/photo-1740432271705-e45aeb5c4ec2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  penthouse: 'https://images.unsplash.com/photo-1679212839469-fb16a48919ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  penthouse2: 'https://images.unsplash.com/photo-1611416457332-946853cc75d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  penthouse3: 'https://images.unsplash.com/photo-1645451365229-676df30167f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  blackCar: 'https://images.unsplash.com/photo-1653407497540-26207a2408d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  blackCar2: 'https://images.unsplash.com/photo-1636446704248-87d51e963e60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  neonCar: 'https://images.unsplash.com/photo-1630769660701-3454835913dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  jacket: 'https://images.unsplash.com/photo-1727515546577-f7d82a47b51d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  watch: 'https://images.unsplash.com/photo-1670177257750-9b47927f68eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
};

export const PLAYER = {
  name: 'Yordy',
  level: 18,
  xp: 12450,
  xpNext: 20000,
  loyaltyCoins: 18450,
  demoBalance: 183.40,
  crew: 'The Syndicate',
  crewReputation: 84300,
  district: 'Downtown',
  avatarInitial: 'Y',
  stats: {
    missionsCompleted: 27,
    crewVictories: 15,
    pvpWins: 8,
    qualifyingRounds: 4326,
  },
};

export const CREW = {
  name: 'The Syndicate',
  level: 14,
  members: 16,
  maxMembers: 20,
  reputation: 84300,
  rank: 12,
  headquarters: 'Downtown',
};

export const NAV = [
  { label: 'City', path: '/city' },
  { label: 'Casino', path: '/casino' },
  { label: 'Missions', path: '/missions' },
  { label: 'Crew', path: '/crew' },
  { label: 'Shop', path: '/shop' },
  { label: 'Profile', path: '/profile' },
];

export const DISTRICTS = [
  { id: 'downtown', name: 'Downtown', locked: false, current: true, players: 43, tag: 'Your District',
    desc: 'The neon heart of Xincity. Loyalty Bank Inc., luxury casinos and your crew headquarters converge under the rain.',
    activities: ['Loyalty Bank Inc.', 'Luxury Casinos', 'Active Missions', 'Player HQ'] },
  { id: 'neon-strip', name: 'Neon Strip', locked: false, players: 61, tag: 'Nightlife', playable: true,
    desc: 'Casinos and nightlife glow until sunrise. This is where all the slots and crash games live \u2014 fast, loud and lit in neon.',
    activities: ['Slots', 'Crash Games', 'Nightclubs', 'Social Spaces'] },
  { id: 'old-quarter', name: 'Old Quarter', locked: false, players: 29, tag: 'Classic', playable: true,
    desc: 'The classic gambling district. Small-stake live casino tables where the old money still plays by candlelight and neon \u2014 stakes up to \u20ac100.',
    activities: ['Live Tables (up to \u20ac100)', 'Classic Roulette', 'Private Rooms'] },
  { id: 'the-port', name: 'The Port', locked: false, players: 34, tag: 'Crew PvP',
    desc: 'Cargo, contraband and crew competition. Territory is won here.',
    activities: ['Crew vs Crew', 'Smuggling Runs', 'Docks Missions'] },
  { id: 'financial', name: 'Financial District', locked: true, unlockLevel: 25, players: 0, tag: 'Locked',
    desc: 'Glass towers and advanced heists. High risk, high status.',
    activities: ['Advanced Missions', 'Corporate Vaults'] },
  { id: 'north-heights', name: 'North Heights', locked: true, unlockLevel: 30, players: 0, tag: 'Prestige',
    desc: 'The prestige district above the clouds. Penthouses, private casinos and legends.',
    activities: ['Prestige Property', 'Elite Society'] },
];

export const CASINO_CATEGORIES = ['All', 'Slots', 'Live', 'New', 'Popular'];

// Fictional demo games (NO real slot artwork) — rendered as generated gradient tiles
const g = (a, b) => `linear-gradient(140deg, ${a}, ${b})`;
export const GAMES = [
  { id: 'crown-of-fortune', title: 'Crown of Fortune', cat: ['Slots','Popular'], grad: g('#3a0d2e','#D90035'), icon: 'Crown', tag: 'Popular', section: 'Recommended' },
  { id: 'deadwood-nights', title: 'Deadwood Nights', cat: ['Slots','New'], grad: g('#120a2e','#7A18FF'), icon: 'Skull', tag: 'New', section: 'Recommended' },
  { id: 'olympus-rising', title: 'Olympus Rising', cat: ['Slots','Popular'], grad: g('#2a0f3a','#B026FF'), icon: 'Zap', tag: 'Hot', section: 'Popular Slots' },
  { id: 'neon-fruits', title: 'Neon Fruits', cat: ['Slots','New'], grad: g('#3a0d1e','#FF204E'), icon: 'Cherry', tag: 'New', section: 'New Games' },
  { id: 'vault-breaker', title: 'Vault Breaker', cat: ['Slots','Popular'], grad: g('#0d1a2e','#7A18FF'), icon: 'Lock', tag: 'Popular', section: 'Popular Slots' },
  { id: 'golden-dragon', title: 'Golden Dragon', cat: ['Slots','Popular'], grad: g('#2e1a06','#E0B85A'), icon: 'Flame', tag: 'Jackpot', section: 'Jackpots' },
  { id: 'midnight-heist', title: 'Midnight Heist', cat: ['Slots','New'], grad: g('#120a2e','#D90035'), icon: 'Gem', tag: 'New', section: 'New Games' },
  { id: 'fortune-city', title: 'Fortune City', cat: ['Slots','Popular'], grad: g('#1a0a2e','#B026FF'), icon: 'Building2', tag: 'Popular', section: 'Recommended' },
  { id: 'live-blackjack', title: 'Neon Blackjack', cat: ['Live','Popular'], grad: g('#0d2e1a','#2FBF71'), icon: 'Spade', tag: 'Live', section: 'Live Casino' },
  { id: 'live-roulette', title: 'Crimson Roulette', cat: ['Live'], grad: g('#3a0d1e','#D90035'), icon: 'Disc', tag: 'Live', section: 'Live Casino' },
  { id: 'wheel-show', title: 'Wheel of Xin', cat: ['Live','Popular'], grad: g('#2a0f3a','#B026FF'), icon: 'CircleDot', tag: 'Show', section: 'Game Shows' },
  { id: 'dice-show', title: 'Dice Palace', cat: ['Live','New'], grad: g('#120a2e','#7A18FF'), icon: 'Dice5', tag: 'Show', section: 'Game Shows' },
  { id: 'mega-jackpot', title: 'Obsidian Jackpot', cat: ['Slots','Popular'], grad: g('#2e1a06','#E0B85A'), icon: 'Trophy', tag: 'Jackpot', section: 'Jackpots' },
  { id: 'ruby-reels', title: 'Ruby Reels', cat: ['Slots','New'], grad: g('#3a0d1e','#FF204E'), icon: 'Sparkles', tag: 'New', section: 'New Games' },
];

export const CASINO_SECTIONS = ['Recommended','Popular Slots','New Games','Live Casino','Game Shows','Jackpots'];

// Up to 6 qualifying slots playable inside the Loyalty Job contribution phase
export const QUALIFYING_SLOTS = GAMES.filter((g) => g.cat.includes('Slots')).slice(0, 6);

// Neon Strip content — slots + crash games
export const NEON_SLOTS = GAMES.filter((g) => g.cat.includes('Slots')).slice(0, 8);
export const CRASH_GAMES = [
  { id: 'neon-rocket', title: 'Neon Rocket', grad: g('#120a2e', '#FF204E'), icon: 'Rocket', tag: 'Crash' },
  { id: 'crimson-ascent', title: 'Crimson Ascent', grad: g('#2a0f1e', '#D90035'), icon: 'TrendingUp', tag: 'Crash' },
  { id: 'vault-climb', title: 'Vault Climb', grad: g('#1a0a2e', '#7A18FF'), icon: 'MoveUpRight', tag: 'Crash' },
  { id: 'midnight-multiplier', title: 'Midnight Multiplier', grad: g('#2a0f3a', '#B026FF'), icon: 'ChevronsUp', tag: 'Crash' },
];

// Old Quarter — small-stake live tables (max €100)
export const LIVE_TABLES = [
  { id: 'crimson-roulette', title: 'Crimson Roulette', grad: g('#3a0d1e', '#D90035'), icon: 'Disc3', tag: 'Live · Max €100' },
  { id: 'old-quarter-blackjack', title: 'Old Quarter Blackjack', grad: g('#0d2e1a', '#2FBF71'), icon: 'Spade', tag: 'Live · Max €100' },
  { id: 'velvet-baccarat', title: 'Velvet Baccarat', grad: g('#2a0f3a', '#B026FF'), icon: 'Diamond', tag: 'Live · Max €100' },
];

export const MISSIONS = [
  { id: 'loyalty-job', title: 'THE LOYALTY JOB', crew: 4, contribution: 20, reward: 1500, difficulty: 'High', location: 'Downtown', status: 'Available', tab: 'Available Missions', route: '/missions/loyalty-job',
    blurb: 'Loyalty Bank Inc. is moving something valuable through Downtown tonight.' },
  { id: 'golden-dragon-heist', title: 'GOLDEN DRAGON HEIST', crew: 4, reward: 2000, difficulty: 'Extreme', location: 'Neon Strip', status: 'Coming Soon', tab: 'Available Missions',
    blurb: 'A legendary vault beneath the Neon Strip. Only the boldest crews need apply.' },
  { id: 'port-smuggling', title: 'PORT SMUGGLING RUN', crew: 3, reward: 800, difficulty: 'Medium', location: 'The Port', status: 'Coming Soon', tab: 'Crew Missions',
    blurb: 'Move the cargo before the patrol changes. Timing is everything.' },
  { id: 'nightclub-takeover', title: 'NIGHTCLUB TAKEOVER', crew: 5, reward: 1200, difficulty: 'High', location: 'Neon Strip', status: 'Coming Soon', tab: 'Crew Missions',
    blurb: 'Take the floor, take the night. Control the strip\'s most exclusive club.' },
  { id: 'midnight-run', title: 'THE MIDNIGHT RUN', crew: 1, contribution: 20, reward: 800, difficulty: 'Medium', location: 'Downtown', status: 'Available', tab: 'Solo Missions', route: '/missions/solo-run',
    blurb: 'A quiet job for one. No crew, no votes — just you, the city and Ghost on comms.' },
  { id: 'ghost-errand', title: "GHOST'S ERRAND", crew: 1, reward: 500, difficulty: 'Low', location: 'Old Quarter', status: 'Coming Soon', tab: 'Solo Missions',
    blurb: 'Ghost needs a package moved through the Old Quarter before dawn. Discreet work.' },
  { id: 'lone-vault', title: 'LONE VAULT', crew: 1, reward: 1000, difficulty: 'High', location: 'Neon Strip', status: 'Coming Soon', tab: 'Solo Missions',
    blurb: 'One operator, one vault, one window. High stakes, no backup.' },
];

export const COMPETITIONS = [
  { id: 'crew-vs-crew', title: 'CREW VS CREW', desc: 'Compete against rival crews in ranked confrontations.', status: 'Preview', route: '/competitions/crew-vs-crew' },
  { id: 'territory-wars', title: 'TERRITORY WARS', desc: 'Crews compete for visible control of Xincity districts.', status: 'Preview', route: '/competitions/territory-wars' },
];

// Mission crew + candidate players
export const MISSION_CREW = [
  { id: 'yordy', name: 'Yordy', role: 'Leader', status: 'Available', level: 18 },
  { id: 'anna88', name: 'Anna88', role: 'Member', status: 'Ready', level: 16 },
  { id: 'marco', name: 'Marco', role: 'Member', status: 'Ready', level: 21 },
  { id: 'wolf', name: 'Wolf', role: 'Member', status: 'Ready', level: 19 },
];
export const OTHER_PLAYERS = [
  { id: 'sofia', name: 'Sofia', status: 'Available', level: 14 },
  { id: 'leo', name: 'Leo', status: 'Offline', level: 12 },
  { id: 'maya', name: 'Maya', status: 'Casino Only', level: 22 },
  { id: 'alex', name: 'Alex', status: 'Do Not Disturb', level: 17 },
];

export const CREW_CHAT_SEED = [
  { id: 1, user: 'Yordy', text: 'Front entrance?', self: true },
  { id: 2, user: 'Marco', text: 'Underground seems safer.' },
  { id: 3, user: 'Anna88', text: 'Higher reward at the front though.' },
  { id: 4, user: 'Wolf', text: "Front entrance. Let's go." },
];

export const CREW_HQ_CHAT = [
  { id: 1, user: 'Anna88', text: 'Anyone doing Loyalty Bank tonight?' },
  { id: 2, user: 'Yordy', text: "I'm in.", self: true },
  { id: 3, user: 'Marco', text: 'Give me five.' },
  { id: 4, user: 'Wolf', text: 'Need one more?' },
];

export const MISSION_ROLES = [
  { role: 'HACKER', player: 'Yordy', effect: 'Reduces the mission target.', icon: 'Terminal' },
  { role: 'DRIVER', player: 'Marco', effect: 'Improves the escape reward.', icon: 'Car' },
  { role: 'INSIDE MAN', player: 'Anna88', effect: 'Unlocks additional story information.', icon: 'Eye' },
  { role: 'MUSCLE', player: 'Wolf', effect: 'Adds a capped mission bonus.', icon: 'Dumbbell' },
];

export const CONTRIBUTIONS = [
  { name: 'Yordy', rounds: 12, points: 2860, grad: g('#3a0d2e','#D90035') },
  { name: 'Marco', rounds: 14, points: 3120, grad: g('#120a2e','#7A18FF') },
  { name: 'Anna88', rounds: 18, points: 2980, grad: g('#2a0f3a','#B026FF') },
  { name: 'Wolf', rounds: 20, points: 3280, grad: g('#3a0d1e','#FF204E') },
];
export const MISSION_TARGET = 9000;
export const MISSION_SCORE = 8740;

export const SHOP_TABS = ['Clothing', 'Vehicles', 'Property', 'Crew', 'Collectibles'];
export const SHOP_ITEMS = [
  { id: 'obsidian-v12', name: 'Obsidian V12', tab: 'Vehicles', price: 12000, img: IMAGES.blackCar, rarity: 'Legendary', desc: 'A hand-built black V12. Silent, fast, unmistakable.' },
  { id: 'shadow-jacket', name: 'Shadow Jacket', tab: 'Clothing', price: 3500, img: IMAGES.jacket, rarity: 'Rare', desc: 'Matte black tailored shell. Worn by those who move unseen.' },
  { id: 'gold-mask', name: 'Gold Mask', tab: 'Collectibles', price: 2500, img: IMAGES.watch, rarity: 'Epic', desc: 'A gilded mask reserved for the trusted few.' },
  { id: 'penthouse-upgrade', name: 'Penthouse Upgrade', tab: 'Property', price: 25000, img: IMAGES.penthouse, rarity: 'Legendary', desc: 'Elevate your Downtown residence to a skyline penthouse.' },
  { id: 'syndicate-badge', name: 'Syndicate Crew Badge', tab: 'Crew', price: 1000, img: IMAGES.redRoom, rarity: 'Rare', desc: 'Wear your allegiance. Recognized across every district.' },
  { id: 'loyalty-escape-car', name: 'Loyalty Bank Escape Car', tab: 'Vehicles', price: 0, img: IMAGES.neonCar, rarity: 'Mission Unlock', desc: 'Unlocked by completing The Loyalty Job. Cannot be purchased.' },
  { id: 'crimson-coupe', name: 'Crimson Coupe', tab: 'Vehicles', price: 8500, img: IMAGES.blackCar2, rarity: 'Epic', desc: 'A low, red-lit coupe built for the Neon Strip.' },
  { id: 'ghost-suit', name: 'Ghost Suit', tab: 'Clothing', price: 5200, img: IMAGES.jacket, rarity: 'Epic', desc: 'A sharp suit that disappears into the night.' },
];

export const PROFILE_ASSETS = [
  { name: 'Obsidian V12', type: 'Vehicle', rarity: 'Legendary', img: IMAGES.blackCar },
  { name: 'Shadow Jacket', type: 'Clothing', rarity: 'Rare', img: IMAGES.jacket },
  { name: 'Gold Mask', type: 'Collectible', rarity: 'Epic', img: IMAGES.watch },
  { name: 'Downtown Penthouse', type: 'Property', rarity: 'Legendary', img: IMAGES.penthouse },
  { name: 'The Syndicate Crew Badge', type: 'Crew', rarity: 'Rare', img: IMAGES.redRoom },
  { name: 'Loyalty Bank Escape Car', type: 'Vehicle', rarity: 'Mission Unlock', img: IMAGES.neonCar },
];

export const ACHIEVEMENTS = [
  { name: 'First Blood', desc: 'Complete your first crew mission', done: true },
  { name: 'City Runner', desc: 'Visit all unlocked districts', done: true },
  { name: 'High Roller', desc: 'Reach Level 18', done: true },
  { name: 'Kingpin', desc: 'Reach Level 25', done: false },
  { name: 'Territory Holder', desc: 'Win a Territory War', done: false },
  { name: 'Legend of Xincity', desc: 'Reach #1 on the leaderboard', done: false },
];

export const PROFILE_HISTORY = [
  { title: 'THE LOYALTY JOB', result: 'Success', reward: '+1,500 LC', when: '2h ago' },
  { title: 'PORT SMUGGLING RUN', result: 'Success', reward: '+800 LC', when: 'Yesterday' },
  { title: 'CREW VS CREW — Round 3', result: 'Victory', reward: '+400 REP', when: '2 days ago' },
  { title: 'NIGHTCLUB TAKEOVER', result: 'Failed', reward: '+500 LC', when: '4 days ago' },
];

export const LEADERBOARD = [
  { rank: 10, crew: 'Crimson Order', rep: 91200 },
  { rank: 11, crew: 'Nightfall', rep: 87500 },
  { rank: 12, crew: 'The Syndicate', rep: 84300, self: true },
  { rank: 13, crew: 'Iron Docks', rep: 80100 },
  { rank: 14, crew: 'Velvet Kings', rep: 77400 },
];

// ——— CREW VS CREW (ranked confrontations) — deterministic demo data ———
export const CVC_TIERS = [
  { name: 'Bronze', color: '#9a6b3f' },
  { name: 'Silver', color: '#9aa3ad' },
  { name: 'Gold', color: '#E0B85A' },
  { name: 'Neon', color: '#FF204E' },
  { name: 'Obsidian', color: '#B026FF' },
];

export const CVC_LADDER = [
  { rank: 1, crew: 'Obsidian Court', rep: 128400, tier: 'Obsidian', wins: 41, losses: 9 },
  { rank: 2, crew: 'Crimson Order', rep: 91200, tier: 'Neon', wins: 35, losses: 14 },
  { rank: 3, crew: 'Nightfall', rep: 87500, tier: 'Neon', wins: 33, losses: 16 },
  { rank: 4, crew: 'The Syndicate', rep: 84300, tier: 'Neon', wins: 31, losses: 15, self: true },
  { rank: 5, crew: 'Iron Docks', rep: 80100, tier: 'Gold', wins: 28, losses: 18 },
  { rank: 6, crew: 'Velvet Kings', rep: 77400, tier: 'Gold', wins: 26, losses: 20 },
];

export const CVC_MATCH = {
  a: { name: 'The Syndicate', color: '#FF204E', roundsWon: 2, players: ['Yordy', 'Marco', 'Anna88', 'Wolf'] },
  b: { name: 'Crimson Order', color: '#B026FF', roundsWon: 1, players: ['Raven', 'Dux', 'Mila', 'Kane'] },
  bestOf: 5,
  round: 4,
  target: 5000,
};

export const CVC_HISTORY = [
  { opp: 'Nightfall', result: 'Victory', score: '3–1', rep: '+420 REP', when: '2 days ago' },
  { opp: 'Iron Docks', result: 'Victory', score: '3–2', rep: '+380 REP', when: '5 days ago' },
  { opp: 'Crimson Order', result: 'Defeat', score: '1–3', rep: '−140 REP', when: '1 week ago' },
  { opp: 'Velvet Kings', result: 'Victory', score: '3–0', rep: '+450 REP', when: '2 weeks ago' },
];

// ——— TERRITORY WARS (district control) — deterministic demo data ———
export const TERRITORY_MAP = [
  { id: 'downtown', name: 'Downtown', holder: 'The Syndicate', color: '#FF204E', influence: 72, self: true, status: 'Held', income: 220 },
  { id: 'neon-strip', name: 'Neon Strip', holder: 'Crimson Order', color: '#B026FF', influence: 58, status: 'Contested', challenger: 'Nightfall', income: 340 },
  { id: 'old-quarter', name: 'Old Quarter', holder: 'Velvet Kings', color: '#E0B85A', influence: 64, status: 'Held', income: 180 },
  { id: 'the-port', name: 'The Port', holder: 'Iron Docks', color: '#2FBF71', influence: 51, status: 'War', challenger: 'The Syndicate', income: 260 },
  { id: 'financial', name: 'Financial District', holder: null, status: 'Locked', unlockLevel: 25 },
  { id: 'north-heights', name: 'North Heights', holder: null, status: 'Locked', unlockLevel: 30 },
];

export const TERRITORY_WAR = {
  district: 'The Port',
  attacker: { name: 'The Syndicate', color: '#FF204E', influence: 49 },
  defender: { name: 'Iron Docks', color: '#2FBF71', influence: 51 },
  endsInSeconds: 3 * 3600 + 42 * 60 + 15,
};

export const TERRITORY_REWARDS = [
  { title: 'District Income', desc: 'Held districts pay Loyalty Coins to the crew pool every day.', icon: 'Coins' },
  { title: 'Visible Control', desc: 'Your crew banner glows over every district you hold — the whole city sees it.', icon: 'Flag' },
  { title: 'Season Trophies', desc: 'Hold the most territory at season end for exclusive crew cosmetics.', icon: 'Trophy' },
  { title: 'HQ Perks', desc: 'Territory unlocks upgrades for your crew headquarters.', icon: 'Building2' },
];
